export const initShellState = {
	url: '/app-:appString',
	name: 'shell.**',
	lazyLoad: async function (transition) {
		const wrongCachedLookLoaded = document.cookie.includes(`NewUI=1`);
		if (wrongCachedLookLoaded && !window.location.href.includes('cacheBreaker=')) {
			window.forceReload();
		}

		const $ocLazyLoad = transition.injector().get('$ocLazyLoad');
		const { shellAppModule } = await import(/* webpackChunkName: "shell" */ './shell');

		await $ocLazyLoad.inject(
			shellAppModule.name,
			{
				rerun: true,
				reconfig: true,
			},
			true
		);

		const agentAppInitializerService = transition.injector().get('mx.sb.shell-app.AgentInitializerService');
		const defaultRouteNotSetState = await agentAppInitializerService.initAgentApp();

		return { states: [defaultRouteNotSetState] };
	},
};

export const keepLocationAfterInitShellState = ($transitions) => {
	$transitions.onBefore({}, async function (transition) {
		const search = transition.router.urlService.search();
		if (transition.redirectedFrom()?.to()?.name === 'shell.**' && (search['view-options'] || search['presetParams'])) {
			transition.options().location = false;
		}
	});
};
